<div class="flex-column" style="border-radius: 20px !important;">
    <!-- HEADER -->
    <div class="flex-column" *ngIf="!!this.data.title" [ngClass]="!!this.data.headerClass ? this.data.headerClass : 'bg-primary-lighter'"
        style="position: sticky; top: 0; z-index:10">
    @if(!!data.data){
        <div class="flex-row align-space-between-center"  style="margin: 4px !important;">
        <div class="flex-column bg-primary-lighter p-1" style="width: 50vh;">
            <span class=" text-primary-darker-h3 ml-1 mbs-1">{{ 'shared.dialog.evolucionar-caso' | exp:'':'Evolucionar Caso' }}</span>
            <span class="flex-100 text-secondary ml-1">  {{this.data.data.patient.surname + ' ' + this.data.data.patient.name + ' ' + (('shared.dialog.dni' | exp:'':'DNI')) + ' ' + this.data.data.patient.documentNumber}} </span>
        </div>
        <button mat-icon-button (click)="close()" [color]="'primary'">
            <mat-icon>highlight_off</mat-icon>
        </button>
    </div>
    }@else {
        <div class="flex-row align-space-between-center"  style="margin: 4px !important;">
            <span class="ml-1" [ngClass]="!!this.data.titleClass ? this.data.titleClass : 'text-primary-darker-h3'">
                {{this.data.title}}
            </span>
            <button mat-icon-button (click)="close()" [color]="'primary'">
                <mat-icon>highlight_off</mat-icon>
            </button>
        </div>
    }
        <!-- TITLE -->
    </div>
    <div [ngClass]="!!this.data.templateClass ? this.data.templateClass : 'p-24'">
        <ng-container [ngTemplateOutlet]="data.template"></ng-container>
    </div>
</div>
